<template>
  <div class="animated fadeIn">
    <div v-if="dashdata" class="row">
      <div class="col-xl">

        <div class="x-cardsection yg y1-grid">
          <div class="y-rot-wrap">
            <div v-if="!isBmwMoto" class="y-rot-txt rot-txt hd-txt">{{ $t('Webportal.DashboardBMW.AllModels') }}</div>
            <div v-else class="y-rot-txt rot-txt hd-txt">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cockpit</div>
          </div>
          <div class="y2-grid" >
            <!-- :class="{ 'y2-grid': hasGklResult() || hasEvResult(), 'y4-grid': hasGklResult() || hasEvResult() == false }" -->
            <!-- Left side -->
            <div ref="leftItem">
              <div :class="{ 'y3-grid': !isBmwMoto, 'y3-grid-moto': isBmwMoto && !showLM, 'y3-grid-moto-lm': isBmwMoto && showLM }" >
                <!-- Header Line -->
                <div class="y-rot-wrap">
                  <div v-if="!isBmwMoto" class="rot-txt y-rot-txt2 hd-txt" style="top:65%;">
                    {{ $t('Webportal.DashboardBMW.PE') }}
                  </div>
                  <div v-else class="rot-txt y-rot-txt2 hd-txt" style="top:65%;">
                    <!-- Empty for Moto -->
                  </div>
                </div>

                <div class="y-border pe-head yg" style="position:relative;">
                  <div class="cont" :class="[ {  over2: isBmwMoto }]">
                    <div  v-if="!isBmwMoto" class="hd-txt" style="line-height: 2.25rem; margin-right: 12px;">
                      {{ $t('Webportal.DashboardBMW.ProcessExcellence') }}
                    </div>
                    <div v-else class="hd-txt" >
                      <div class="col-auto col-md-auto" style="display: inline-flex;" >
                        <!-- Toggle Legengary Moments visible or not -->
                        <div>
                          <b-button @click="toggleShowLegendaryMoments" 
                                    size="sm" variant="primary"
                                    style="width:12rem; margin: 2.5px;">
                            <span v-if="!showLM">{{ $t('Webportal.Dashboard.Show')}}</span><span v-else>{{ $t('Webportal.Dashboard.Hide')}}</span> {{ $t('Webportal.DashboardBMW.LegendaryMoments')}}
                          </b-button>
                        </div>
                        <div v-if="showLM" style="margin-left: 2rem; margin-right: 1rem;margin-top: 0.33rem;">
                          Total:
                        </div>
                        <div v-if="showLM" class="hd-dark" style="background-color: rgba(1, 1, 1, 0.25);">
                          <performanceitem  :overallByWave="getOverallByWave"
                                            :kpi="getKpiGroupByString2('Legendary Moments Total')"
                                            :isStandalone="true"
                                            :flipArrowColor="true"
                                            :showInlineYtd="true"
                                            :thresholds="thresholds" />
                        </div>
                        <button v-if="getKpiGroupByString2('Legendary Moments Total')"
                          class="kpi-question-button ml-2"
                          @click="handleKpiQuestionsClick(getKpiGroupByString2('Legendary Moments Total'))">
                          <font-awesome-icon :icon="['far', 'list']" /> {{ $t('Webportal.DashboardBMW.Q&A') }}
                        </button>
                      </div>
                      <div class="col-auto col-md-auto">
                      </div>
                    </div>
                    <div>
                      <performanceitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiGroupByString2('Process Excellence')"
                                        :isStandalone="true"
                                        :showInlineYtd="true"
                                        :thresholds="thresholds" />
                    </div>
                    <button v-if="getKpiGroupByString2('Process Excellence')"
                      class="kpi-question-button"
                      @click="handleKpiQuestionsClick(getKpiGroupByString2('Process Excellence'))">
                      <font-awesome-icon :icon="['far', 'list']" /> {{ $t('Webportal.DashboardBMW.Q&A') }}
                    </button>
                  </div>
                </div>

                <!-- Cluster Headers Line -->
                <div class="y-rot-wrap">
                  <div v-if="!isBmwMoto" class="rot-txt y-rot-txt2 hd-txt" style="top:95%;">
                    {{ $t('Webportal.DashboardBMW.Cluster') }}
                  </div>
                  <div v-else class="rot-txt y-rot-txt2 hd-txt" style="top:85%;">
                    GROUP
                  </div>
                </div>

                <!-- Header 1 -->
                <div v-if="!isBmwMoto" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiContact"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else-if="isBmwMoto && !showLM" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('Customer Experience Check-up')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('Legendary Moment: Product Offer Presentation & Consultation')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <!-- Header 2 -->
                <div v-if="!isBmwMoto" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiSalesConsultation"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else-if="isBmwMoto && !showLM" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('Online Process')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('Legendary Moment: Experience @ POS')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <!-- Header 3 -->
                <div v-if="!isBmwMoto" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiTestDrive"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else-if="isBmwMoto && !showLM" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('The 5 MUST')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('Legendary Moment: Integrated Offer and Pricing')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                
                <!-- Header 4 -->
                <div v-if="!isBmwMoto" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiOffer"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else-if="isBmwMoto && !showLM" class="cl-head" style="grid-column: span 2;">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGroupByString2('Contractual Standards')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div v-else class="cl-head" style="grid-column: span 2;">
                 <!-- 2nd column Legendary Moment: Experience @ POS -->
                </div>

                <!-- Header 5 (only cars) -->
                <div v-if="!isBmwMoto" class="cl-head">
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiContactCare"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>

                <!-- KPI Line -->
                <div class="y-rot-wrap">
                  <div class="rot-txt y-rot-txt2 hd-txt">
                    {{ $t('Webportal.DashboardBMW.SingleKPI') }}
                    <!-- TODO Switch to legendary moments text --> 
                  </div>
                </div>

                <!-- 1st col -->
                <div class="mgt">
                  <!-- Online Enquiry -->
                  <div v-if="!isBmwMoto" class="kpi-frame ti_border_dark" v-bind:class="onlBorderClass">

                    <div class="kpi-frame-head">{{ $t('Webportal.DashboardBMW.OnlineEnquiry') }}</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactOnlineAutoResponse"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactOnlinePersonalResponse"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactOnlineLostLeads"
                              :isDark="true"
                              :hasDashBorder="true"
                              :isHeader="false"
                              :thresholds="leadFuThresholds" />
                              <!-- :isLostLead="true" -->
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactOnlineQualityStandards"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else-if="isBmwMoto && !showLM" class="kpi-frame-inv" v-bind:class="onlBorderClass">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('1A. Online Enquiry')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('1B. Telephone Enquiry')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2. Sales Consultation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('3. Test Ride')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4. Offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('5. Contact Care')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else class="kpi-frame-inv" v-bind:class="onlBorderClass">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.0 Display of models')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.1 Welcoming')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.2 Assessment welcoming & greeting')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.3 Need analysis')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.4 Assistance configuration')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.5 Product presentation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.6 Assessment product presentation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.7 Detailed product information')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.2.1 Contact details in offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>

                  <!-- Telephone Enquiry -->
                  <div v-if="!isBmwMoto" class="kpi-frame ti_border_dark" v-bind:class="telBorderClass">
                    <div class="kpi-frame-head">{{ $t('Webportal.DashboardBMW.TelephoneEnquiry') }}</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactTelephoneReachability"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactTelephoneLostLeads"
                              :hasDashBorder="true"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="leadFuThresholds" />
                              <!-- :isLostLead="true" -->
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactTelephoneQualityStandards"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                </div>
                <!-- 2nd col -->
                <div class="mgt">
                  <div v-if="!isBmwMoto" class="kpi-frame-inv">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Online configuration')"
                              :isDark="true"
                              :isHeader="false"
                              :hasDashBorder="true"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiSalesConsultationNeedAnalysis"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiSalesConsultationInterestInCompetitorCars"
                              :isDark="true"
                              :isHeader="false"
                              :hasDashBorder="true"
                              :monochrome="true"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Charging Possibilities')"
                              :hasDashBorder="false"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiSalesConsultationVehiclePresentation"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('xEV Vehicle Features')"
                              :hasDashBorder="false"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  v-if="!dataForYearAndOngoing(2024)"
                              :overallByWave="getOverallByWave"
                              :kpi="getKpiSalesConsultationGeniusBenefit"
                              :hasDashBorder="true"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  v-if="dataForYearAndOngoing(2024)"
                              :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('App Introduction')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="lmThresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Sustainability')"
                              :isDark="true"
                              :isHeader="false"
                              :hasDashBorder="true"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else-if="isBmwMoto && !showLM" class="kpi-frame-inv">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Online configuration')"
                              :isDark="true"
                              :isHeader="false"
                              :hasDashBorder="true"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Auto Response')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('First personal contact (up to 5 working days)')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Next steps')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Reference to enquiry')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                              <!-- :isLostLead="true" -->
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Setting an appointment')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  v-if="dataForYearAndOngoing(2024)"
                              :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('App Introduction')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('Sustainability')"
                              :isDark="true"
                              :isHeader="false"
                              :hasDashBorder="true"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else class="kpi-frame-inv" v-bind:class="onlBorderClass">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('3.1 Test ride offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('3.2 Test ride requirements')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('3.3 Assessment test ride experience')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('3.4 Test ride preparation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('3.5 Customer experience')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('5.1 Business card')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('5.2 Assessment overall experience')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                </div>
                <!-- 3rd col -->
                <div class="mgt">
                  <div v-if="!isBmwMoto" class="kpi-frame-inv">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiTestDriveOffer"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiTestDriveConducted"
                              :hasDashBorder="true"
                              :monochrome="false"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="testDriveConductedThresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiTestDriveRequirements"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('TD xEV Requirements')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else-if="isBmwMoto && !showLM" class="kpi-frame-inv">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('01. Contact')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('02. Test ride offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('03. Sales proposition')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('04. Finance offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('05. Follow up')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else class="kpi-frame-inv" v-bind:class="onlBorderClass">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.2 Individual offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.3 Price quotation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.4 Financing & leasing offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.5 Service Packages offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.6 Assessment offer explanation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('5.3.1/5.3.2 Follow up')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                </div>
                <!-- 4th col -->
                <div v-if="(isBmwMoto && !showLM) || !isBmwMoto" class="mgt">
                  <div v-if="!isBmwMoto" class="kpi-frame-inv">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiOfferStandardsFullfilled"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiSFProductRatio"
                              :hasDashBorder="true"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiOfferTradeInOffer"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiOfferMarketingOptIn"
                              :hasDashBorder="true"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div v-else-if="isBmwMoto && !showLM" style="grid-column: span 1;">
                    <div class="kpi-frame-inv">
                      <div  class="kpi-frame-head">&nbsp;</div>
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Personal Response')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Active Welcome')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Product presentation')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Detailed product information')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Test ride offer')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Test ride procedure requirements')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Test ride vehicle preparation')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Finance offer')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Sales proposition')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                      <kpiitem  :overallByWave="getOverallByWave"
                                :kpi="getKpiByString('Follow up')"
                                :isDark="true"
                                :isHeader="false"
                                :fixContractualStandards="true"
                                :showStandard="false"
                                :thresholds="thresholds" />
                    </div>
                  </div>
                  <div v-else class="kpi-frame-inv" v-bind:class="onlBorderClass">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.3-Need analysis')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.6-Assessment product presentation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('2.7-Detailed product information')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.2-Individual offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.3-Price quotation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.4-Financing & leasing offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.5-Service Packages offer')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiByString('4.6-Assessment offer explanation')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                </div>

                <!-- 5th col -->
                <div v-if="!isBmwMoto" class="mgt">
                  <div class="kpi-frame-inv">
                    <div class="kpi-frame-head">&nbsp;</div>
                    <kpiitem  v-if="!dataForYearAndOngoing(2024)"
                              :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareCourtesyMessage"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />

                    <kpiitem  v-if="!dataForYearAndOngoing(2024)"
                              :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareCourtesyMessageContent"
                              :hasDashBorder="true"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />

                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareAppointmentFU"
                              :hasDashBorder="true"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />

                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareFollowUp"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div class="kpi-frame-inv" v-if="getKpiContactCareFollowUpOnline">
                    <div class="kpi-frame-head narrow_05">{{ $t('Webportal.DashboardBMW.OnlyOnlineWithoutPhysicalVisit') }}</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareFollowUpOnline"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div class="kpi-frame ti_border_dark" v-if="showCsqGermany">
                    <div class="kpi-frame-head">{{ $t('Webportal.DashboardBMW.CsqGermany') }}</div>
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareCsqAppointment"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareCsqPremium"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiContactCareCsqVisitorExperience"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Right side header ..  v-if="hasGklResult() || hasEvResult()"-->
            <div class="y-rot-wrap" ref="rightItem">
              <div v-if="!isBmwMoto" class="y-rot-txt rot-txt hd-txt" style="width: 40px;">{{ $t('Webportal.DashboardBMW.SpecificModelKPI') }}</div>
              <div v-else class="y-rot-txt rot-txt hd-txt" style="width: 40px;"></div>
            </div>

            <!-- Right side contents ...  v-if="hasGklResult() || hasEvResult()"-->
            <div>
              <div class="y-rot-wrap xev-head"  style="position:relative;">
                <div v-if="!isBmwMoto" class="yhead head-cont-xev">
                  <div class="px-1 my-0"  style="line-height: 2.25rem; font-size: 16px;">
                    {{ $t('Webportal.DashboardBMW.xEV') }}
                  </div>
                  <div class="px-2 pi-color-fix">
                    <performanceitem  :overallByWave="getOverallByWave"
                                      :kpi="getKpiGroupByString2('xEV Readiness')"
                                      :isStandalone="true"
                                      :compressHorizontally="true"
                                      :showInlineYtd="true"
                                      :thresholds="lmThresholds" />
                  </div>
                  <button v-if="getKpiGroupByString2('xEV Readiness')"
                    class="kpi-question-button ml-auto"
                    @click="handleKpiQuestionsClick(getKpiGroupByString2('xEV Readiness'))">
                    <font-awesome-icon :icon="['far', 'list']" /> {{ $t('Webportal.DashboardBMW.Q&A') }}
                  </button>
                </div>
                <div v-else class="yhead">{{ $t('Webportal.DashboardBMW.CustomerTreatment') }}</div>
              </div>
              <div v-if="isBmwMoto" style="margin: 4px;"></div>

              <div v-if="!isBmwMoto" class="xev-spacing">
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpixEvNeedAnalysis"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpixEvProductPresentation"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpixEvHomeChargingProducts"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpixEvPublicChargingOffering"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                </div>
                <div>
                  <kpiitem  v-if="!dataForYearAndOngoing(2024)"
                            :overallByWave="getOverallByWave"
                            :kpi="getKpixEvGovRegionalSupport"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                  <kpiitem  v-else
                            :overallByWave="getOverallByWave"
                            :kpi="getKpiBatteryChargingStatus"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                  
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpixEvTestDriveRequirements"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="lmThresholds" />
                </div>
              </div>
              <div v-else>
                <div>
                  <div class="cl-head" style="grid-column: span 2;">
                    <kpiitem  :overallByWave="getOverallByWave"
                              :kpi="getKpiGroupByString2('Customer Treatment')"
                              :isDark="true"
                              :isHeader="false"
                              :thresholds="thresholds" />
                  </div>
                  <div class="kpi-frame-head" style="margin: 4px;">&nbsp;</div>

                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiByString('01. Welcome')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiByString('02. Explanation of the motorbike')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiByString('03. Test ride experience')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiByString('04. Offer explanation')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiByString('05. Premium experience')"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
              </div>

              <div v-if="!isBmwMoto" class="y-rot-wrap xev-head">
                <div class="yhead" style="line-height: 2.0rem;">{{ $t('Webportal.DashboardBMW.GKL') }}</div>
              </div>
              <div v-if="!isBmwMoto" style="margin: 2px;">
                <div>
                  <kpiitem  v-if="!dataForYearAndOngoing(2024)"
                            :overallByWave="getOverallByWave"
                            :kpi="getKpiGklVehiclePresentation"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  v-if="!dataForYearAndOngoing(2024)"
                            :overallByWave="getOverallByWave"
                            :kpi="getKpiGklDeliveryOfTestVehicle"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGklTestDriveExperience"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
                <div>
                  <kpiitem  :overallByWave="getOverallByWave"
                            :kpi="getKpiGklCustomerTreatment"
                            :hasDashBorder="true"
                            :isDark="true"
                            :isHeader="false"
                            :thresholds="thresholds" />
                </div>
              </div>
            </div>

            <!-- Bottom line -->
            <div class="y-rot-wrap bl">
              <div v-if="!isBmwMoto" class="y-rot-txt2 rot-txt hd-txt" style="top:95%;">{{ $t('Webportal.DashboardBMW.SpecialEvaluations')}}</div>
              <div v-else class="y-rot-txt2 rot-txt hd-txt" style="top:95%;"></div>
              <div class="bl-border" />
              <div class="bl-container">
                <div class="bl-sp">
                  <!-- Recommendations -->
                  <div v-if="!isBmwMoto && !dataForYearAndOngoing(2024)" class="bl-sp-item">
                    <div class="y-rot-wrap" style="display: none; height: 100%; margin: 0px;">
                      <div class="y-rot-txt2 rot-txt hd-txt" style="top:95%;">{{ $t('Webportal.Dashboard.Recommendations')}}</div>
                      <div class="bl-border" />
                      <div class="bl-container">
                        <div class="dnt" style="height: 6pc;">
                          <div></div>
                          <div >
                            <DoughnutChart  export-element-ignore 
                                            v-if="hasNpsScore()"
                                            style="width: 6pc; height: 6pc; display: block;"
                                            :thresholds="thresholds"
                                            :chartData="getRecommendationChartData(getKpiRecommendation)" />
                          </div>
                          <div></div>
                        </div>
                        <p class="narrow_05" style="color: #000; font-weight: bold; margin-bottom: 4px; text-align: center;">{{ $t('Webportal.DashboardBMW.NetPromoterScore') }}</p>
                        <div style="padding: 0rem 0.75rem;">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiRecommendation"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :monochrome="true"
                                    :thresholds="thresholds" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Excitement ... v-if="visualizeExcitement(this.optionsdata) && !isBmwMoto" -->
                  <div  v-if="!isBmwMoto && !dataForYearAndOngoing(2024)" 
                        class="bl-sp-item">
                    <div  class="y-rot-wrap" 
                          style="height: 100%; margin: 0px;"
                          :style="{ 'display': dataForYearAndOngoing(2024) ? 'none' : 'inherit' }">
                      <div class="y-rot-txt2 rot-txt hd-txt" style="top:95%;">{{ $t('Webportal.DashboardBMW.ExcitementRating')}}</div>
                      <div class="bl-border" />
                      <div class="bl-container">
                        <div>
                          <div>
                            <div class="shead yg">
                              <span style="padding-inline: 1rem;text-transform: uppercase;">{{ $t('Webportal.Dashboard.Overall')}} {{ getStarsValueCalulationText([this.getKpiExcitementDigital, this.getKpiExcitementPhysical, this.getKpiExcitementPsychological], '-') }}</span>
                              <span><stars-score :score="getStarsValueCalulation([this.getKpiExcitementDigital, this.getKpiExcitementPhysical, this.getKpiExcitementPsychological], NaN)" color="#eee" /></span>
                            </div>
                          </div>
                          <div>
                            <kpi-star-item  :overallByWave="getOverallByWave"
                                            :kpi="getKpiExcitementDigital"
                                            :hasDashBorder="true"
                                            :monochrome="true"
                                            :isDark="true"
                                            :isHeader="false"
                                            :thresholds="thresholds" />
                          </div>
                          <div>
                            <kpi-star-item  :overallByWave="getOverallByWave"
                                            :kpi="getKpiExcitementPhysical"
                                            :hasDashBorder="true"
                                            :monochrome="true"
                                            :isDark="true"
                                            :isHeader="false"
                                            :thresholds="thresholds" />
                          </div>
                          <div>
                            <kpi-star-item  :overallByWave="getOverallByWave"
                                            :kpi="getKpiExcitementPsychological"
                                            :hasDashBorder="true"
                                            :monochrome="true"
                                            :isDark="true"
                                            :isHeader="false"
                                            :thresholds="thresholds" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bl-sp-item">
                  </div>            

                  <!-- Retail Next -->
                  <div class="bl-sp-item span-two">
                    <div class="retail-next-area">
                      <div class="retail-next-header">Retail Next</div>
                      <div class="retail-next-grid">
                        <kpiitem  :overallByWave="getOverallByWave"
                                  :kpi="getKpiByString('Digital displays active')"
                                  :isDark="true"
                                  :isHeader="false"
                                  :thresholds="thresholds" />
                        <kpi-star-item  :overallByWave="getOverallByWave"
                                          :kpi="getKpiByString('Living room atmosphere')"
                                          :hasDashBorder="true"
                                          :isStandalone="true"
                                          :monochrome="true"
                                          :isDark="true"
                                          :isHeader="false"
                                          :thresholds="thresholds" />
                        <kpiitem  :overallByWave="getOverallByWave"
                                  :kpi="getKpiByString('Active vehicle presentation in showroom')"
                                  :isDark="true"
                                  :isHeader="false"
                                  :thresholds="thresholds" />
                        <kpi-star-item  :overallByWave="getOverallByWave"
                                        :kpi="getKpiByString('Decoration')"
                                        :showPrewaves="true"	
                                        :hasDashBorder="true"
                                        :monochrome="true"
                                        :isStandalone="true"
                                        :isDark="true"
                                        :isHeader="false"
                                        :thresholds="thresholds" />
                      </div>
                    </div>
                  </div>

                  <!-- Digital Readiness -->
                  <div v-if="!isBmwMoto" class="bl-sp-item">
                    <div class="y-rot-wrap" style="height: 100%; margin: 0px;">
                      <div class="y-rot-txt2 rot-txt hd-txt" style="top:95%;">{{ $t('Webportal.DashboardBMW.DigitalReadiness')}}</div>
                      <div class="bl-border" />
                      <div class="bl-container">
                        <div>
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiDigitalReadinessDirectAppointmentBookingOnline"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :thresholds="thresholds" />
                        </div>
                        <div>
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiDigitalReadinessOnlineConsultationOffered"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :thresholds="thresholds" />
                        </div>
                        <div>
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiDigitalReadinessMyBMWApp"
                                    :hasDashBorder="true"
                                    :disabled="false"
                                    :isDark="true"
                                    :isHeader="false"
                                    :thresholds="lmThresholds" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Legendary Moments: Group Results -->
                  <div v-if="!isBmwMoto" class="bl-sp-item">
                    <div class="y-rot-wrap" style="margin: 0px; height: 65%;">
                      <div class="y-rot-txt2 rot-txt hd-txt" style="top:95%;">{{ $t('Webportal.DashboardBMW.LegendaryMoments')}}</div>
                      <div class="bl-border" />
                      <div class="bl-container">
                        <div>
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiLegendaryMomentIntegratedOffer"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :thresholds="lmThresholds" />
                        </div>
                        <div>
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiLegendaryMomentTestDrive"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :thresholds="lmThresholds" />
                        </div>
                      </div>
                    </div>
                    <div  class="y-rot-wrap" style="height: 34%; margin: 0px; margin-top: 2px;">
                      <div class="y-rot-txt2 rot-txt hd-txt" style="top:95%;">NPS</div>
                      <div class="bl-border" />
                      <div class="bl-container">
                        <div>
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiRecommendation"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :monochrome="true"
                                    :thresholds="thresholds" />
                        </div>
                      </div>
                    </div>
                  </div>


                  <!-- #Shops -->
                  <div class="bl-sp-item">
                    <div class="y-rot-wrap" style="height: 100%; margin: 0px;">
                      <div class="y-rot-txt2 rot-txt hd-txt" style="top:95%;text-transform: uppercase;">#{{ $t('Webportal.DashboardBMW.NumberOfShops')}}</div>
                      <div class="bl-border" />
                      <div class="bl-container">
                        <ShopsOverall style="width: 100%;"
                                      :coloredHeader="false"
                                      :overallValues="getOverallByWave"
                                      :isCompetitionOverall="false"
                                      :isUsedCar2021="isUsedCar2021"
                                      :isBmwMoto="isBmwMoto" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div  class="divider-hor" />

        <!-- Legende -->
        <div class="un-line">

          <div class="un-block" v-if="hasNpsScore()">
            <NpsLegend class="card-2022" />
          </div>

          <div v-if="!isBmwMoto" class="un-block" style="margin-left: -12px;">
            <KpiWithPointsLegend />
          </div>

          <!-- v-if="(visualizeExcitement(this.optionsdata) && !isBmwMoto)" -->
          <div v-if="!isBmwMoto" class="un-block">
            <!-- Performance Index -->
            <legend-control :isBMW2020="true"
                            :titleText="$t('Webportal.DashboardBMW.PerformanceIndex')"
                            :isWide="true"
                            :thresholds="thresholds"
                            :showTextItems="false" />
          </div>
                    
          <div class="un-block" v-if="!isBmwMoto">
            <!-- Performance Index -->
            <legend-control :isBMW2020="false"
                            :leadFuThresholds="leadFuThresholds"
                            :showTextItems="false" />
          </div>

          <div class="un-block" v-if="!isBmwMoto">
            <!-- Performance Index -->
            <legend-control :isBMW2020="false"
                            :isWide="true"
                            :lmThresholds="lmThresholds"
                            :showTextItems="false" />
          </div>
          
          <div class="un-block" v-if="!isBmwMoto">
            <!-- Performance Index -->
            <legend-control :thresholds="testDriveConductedThresholds"
                            :subTitleText="getKpiTestDriveConducted?.KpiName"
                            :isWide="true"
                            :showTextItems="false" />
          </div>
          <div class="un-block">
            <!-- Performance Index -->
            <legend-control v-if="isBmwMoto"
                            :isBMW2020="false"
                            :thresholds="thresholds"
                            :showTextItems="false" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomKpiSorting from '@/mixins/CustomKpiSorting';
  import BrandMixin from '@/mixins/BrandMixin';
  import performanceitem from './Year2021/PerformanceItem2021';
  import kpiitem from './Year2021/KpiItem2021';
  import kpistaritem from './Year2021/KpiStarItem';
  import StarsScore from './StarsScore';
  import NpsLegend from './Year2020/NpsLegend';
  import ThresholdColorMixin from '@/mixins/bmw/ThresholdColor';
  import KpiWithPointsLegend from './Year2020/KpiWithPointsLegend';
  import tableitem from './TableItem';
  import LegendControl from './Year2021/LegendControl';
  import ShopsOverall from './Year2021/ShopsOverall2021';
  import DoughnutChart from '@/components/DoughnutChart';
  import StarCalculationMixin from '@/mixins/StarCalculationMixin.js';
  import EventBus from '@/services/EventBus.js'

  export default {
    mixins: [ CustomKpiSorting, BrandMixin, StarCalculationMixin, ThresholdColorMixin ],

    props:{
      activeYears: { type: Array },
      yearsList: { type: Array },
      yearsbywave: { type: Array },
      dashdata: { type: Object },
      optionsdata: { type: Object },
      isBmwMoto: { type: Boolean },
      isUsedBike: { type: Boolean },
      isBmwM: { type: Boolean },
      isBmwi: { type: Boolean },
      isUsedCar: { type: Boolean },
      isUsedCar2021: { type: Boolean, default: false, },
      isGebrauchtwagen: { type: Boolean },
      selectedBrand: { type: Array },
      selection: { type: Object },
      thresholds: { type: Array, required: true },
      thresholdSetting: { type: Object, required: true }
    },

    components:{
      performanceitem,
      kpiitem,
      'stars-score': StarsScore,
      'kpi-star-item': kpistaritem,
      'legend-control': LegendControl,
      ShopsOverall,
      DoughnutChart,
      tableitem,
      NpsLegend,
      KpiWithPointsLegend
    },

    data() {
      return {
        telBorderClass: {
          'ti_border_inactive': !this.hasTelephoneEnquiry
        },
        onlBorderClass: {
          'ti_border_inactive': !this.hasOnlineEnquiry
        },
        showLM: false
      }
    },

    methods: {
      dataForYearAndOngoing(year) {
        return this.activeYears.some(x => x >= year);
      },

      handleKpiQuestionsClick(kpi) {
        EventBus.$emit('Modal-Kpi-Questions', { visible: true, kpi: kpi });
      },

      getLegendStyle(value) {
        let item = _.find(this.thresholdSetting.options, [ 'value', value ]);
        if  (!item) return { background: 'red'};
        if (item.value != this.thresholdSetting.selected)
          return { opacity: '33%'};
      },

      getCustomOnlineProcessKpi() {
        let onlProc = this.createKpi('Online Process', 'Online Process', 'Process Excellence');
        let kpiList = this.getKpiList([ 'Auto Response', 'First personal contact (up to 5 working days)', 'Next steps', 'Reference to enquiry', 'Setting an appointment']);
        onlProc.SurveyWave = this.getEqualWeightedSurveyWaves(kpiList);
        onlProc.YTD = this.getEqualWeightedYTD(kpiList);
        return onlProc;
      },
      getCustomFiveMustKpi() {
        let fiveMust = this.createKpi('5 MUST', '5 MUST', 'Process Excellence');
        let kpiList = this.getKpiList(['1A. Online Enquiry', '1B. Telephone Enquiry', '2. Sales Consultation', '3. Test Ride', '4. Offer', '5. Contact Care' ]);
        fiveMust.SurveyWave = this.getEqualWeightedSurveyWaves(kpiList);
        fiveMust.YTD = this.getEqualWeightedYTD(kpiList);
        return fiveMust;
      },
      getEqualWeightedYTD(kpis) {
        let items = [];
        // Result Year
        for (const kpi of kpis) {
          for (const ytd of kpi.YTD) {
            let res = _.find(items, (x) => x.Year == ytd.Year);
            if (!res) {
              res = { Year: ytd.Year, Result: 0, ResultCounter: 0 };
              items.push(res);
            }
            res.Result += ytd.Result;
            res.ResultCounter += 1;
          }
        }
        let slots = 0;
        for (const item of items) {
          slots = slots + 1;
          item.Result = Math.round(item.Result / item.ResultCounter);
        }
        return items;
      },
      getEqualWeightedSurveyWaves(kpis) {
        let items = [];
        var _overall = this.getKpiGroupOverall

        for (const kpi of kpis) {
          for (const wave of kpi.SurveyWave) {
            let w = _.find(items, (x) => x.Name == wave.Name);
            if (!w) {
              w = { Name: wave.Name, Result: 0, Year: wave.Year, ResultCounter: 0 };
              items.push(w);
            }
            w.Result = w.Result + wave.Result;
            w.ResultCounter = w.ResultCounter + 1;
          }
        }
        let slots = 0;
        for (const item of items) {
          slots = slots + 1;
          item.Slot = slots;
          item.Result = Math.round(item.Result / item.ResultCounter);
        }
        _.findLast(items, (i) => i.Slot = 101 );
        return items;
      },

      getKpiList(names) {
        let items = [];
        for (const name of names) {
          let item = this.getKpiByString(name);
          if (item) {
            items.push(item);
          }
        }
        return items;
      },

      createKpi(code, name, group) {
        return {
          KpiCode: code,
          KpiName: name,
          KpiGroupCode: group,
          SurveyWave:[],
          YTD: [],
          Tagged: true
        };
      },

      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          if (item) return item
        }
      },
      getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0) {
          return _.find(this.dashdata.OverallByWave, (x) => x.KpiCode === code)
        }

      },
      getKpiGroupByString2: function (code) {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0) {
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === code)
        }

      },
      hasEvResult: function() {
        return !_.isEmpty(this.getKpixEvNeedAnalysis)
            || !_.isEmpty(this.getKpixEvProductPresentation)
            || !_.isEmpty(this.getKpixEvHomeChargingProducts)
            || !_.isEmpty(this.getKpixEvPublicChargingOffering)
            || !_.isEmpty(this.getKpixEvGovRegionalSupport)
            || !_.isEmpty(this.getKpixEvTestDriveRequirements);
      },
      hasGklResult: function() {
        return !_.isEmpty(this.getKpiGklVehiclePresentation)
            || !_.isEmpty(this.getKpiGklDeliveryOfTestVehicle)
            || !_.isEmpty(this.getKpiGklTestDriveExperience)
            || !_.isEmpty(this.getKpiGklCustomerTreatment);
      },
      hasNpsScore() {
        return !_.isEmpty(this.getRecommendationChartData(this.getKpiRecommendation));
      },
      hasOnlineEnquiry: function() {
        let result = !_.isEmpty(this.getKpiContactOnlineAutoResponse)
                  || !_.isEmpty(this.getKpiContactOnlinePersonalResponse)
                  || !_.isEmpty(this.getKpiContactOnlineLostLeads)
                  || !_.isEmpty(this.getKpiContactOnlineQualityStandards);
        return result;
      },
      hasTelephoneEnquiry: function() {
        let result = !_.isEmpty(this.getKpiContactTelephoneReachability)
                  || !_.isEmpty(this.getKpiContactTelephoneLostLeads)
                  || !_.isEmpty(this.getKpiContactTelephoneQualityStandards);
        return result;
      },
      hasRecommendationChartData: function(kpi) {
        if (_.isEmpty(kpi)) {
          return false;
        }

        return !_.isEmpty(kpi.SurveyWave);
      },
      getRecommendationChartData: function(kpi) {
        if (_.isEmpty(kpi) || _.isEmpty(kpi.SurveyWave)) {
          return {};
        }

        let wave = _.last(kpi.SurveyWave);
        let dataPoints = [
          wave.ResultPromoters,
          100 - wave.ResultDetractors - wave.ResultPromoters,
          wave.ResultDetractors
        ];

        let result = {
          labels: [
            this.$t('Webportal.DashboardBMW.Promoters'),
            this.$t('Webportal.DashboardBMW.Passives'),
            this.$t('Webportal.DashboardBMW.Detractors')],
          datasets: [
            {
              backgroundColor: [ this.thresholds[2].Color, this.thresholds[1].Color, this.thresholds[0].Color ],
              data: dataPoints
            }
          ]
        };
        return result;
      },
      toggleShowLegendaryMoments() {
        this.showLM = !this.showLM;
      }
    },

    computed: {
      lmThresholds() {
        return this.getLMThresholds(this.thresholds);
      },

      leadFuThresholds() {
        return this.makeLeadFuThresholds(this.thresholds);
      },
      testDriveConductedThresholds() {
        return this.testDriveConductedThreshold(this.thresholds);
      },

      showCsqGermany: function() {
        return !_.isEmpty(this.getKpiContactCareCsqPremium)
            || !_.isEmpty(this.getKpiContactCareCsqVisitorExperience)
      },
      getKpiGroupOverall: function() {
        return this.getKpiGroupByString('00. Overall')
      },

      getKpiGroupOverallOrdered: function() {
        let item = this.getKpiGroupByString('00. Overall');
        return this.getOrderedKpi(item);
      },

      getKpiGroupOverallKpiName: function() {
        var item = this.getKpiGroupOverall;
        if (item) {
          return item.KpiName
        }
      },

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      isKpiGroupOverallVisible: function () {
        var _kpi = this.getKpiGroupOverall
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      hasDashdata: function () {
        return _.isEmpty(this.dashdata);
      },

      // 1
      getKpiContact: function() {
        return this.getKpiByString('1. Contact')
      },
      getKpiContactOnlineAutoResponse: function() {
        return this.getKpiByString('Auto response (instantly)')
      },
      getKpiContactOnlinePersonalResponse: function() {
        return this.getKpiByString('Personal response')
      },
      getKpiContactOnlineLostLeads: function() {
        return this.getKpiByString('Lead FU (Onl. Enq.)')
      },
      getKpiContactOnlineQualityStandards: function() {
        return this.getKpiByString('QoR: Standards (onl)')
      },
      getKpiContactTelephoneReachability: function() {
        return this.getKpiByString('Reachability')
      },
      getKpiContactTelephoneLostLeads: function() {
        return this.getKpiByString('Lead FU (Tel. Enq.)')
      },
      getKpiContactTelephoneQualityStandards: function() {
        return this.getKpiByString('QoR: Standards (tel)')
      },

      // 2
      getKpiSalesConsultation: function() {
        return this.getKpiByString('2. Sales Consultation')
      },
      getKpiSalesConsultationInterestInCompetitorCars: function() {
        return this.getKpiByString('Interest in Competitor Cars');
      },
      getKpiSalesConsultationNeedAnalysis: function() {
        return this.getKpiByString('Need analysis')
      },
      getKpiSalesConsultationVehiclePresentation: function() {
        return this.getKpiByString('Product presentation')
      },
      getKpiSalesConsultationGeniusBenefit: function() {
        return this.getKpiByString('Genius Benefit')
      },

      // 3
      getKpiTestDrive: function() {
        return this.getKpiByString('3. Test Drive')
      },
      getKpiTestDriveOffer: function() {
        return this.getKpiByString('Test Drive Offer')
      },
      getKpiTestDriveConducted: function() {
        return this.getKpiByString('Test Drive conducted')
      },
      getKpiTestDriveRequirements: function() {
        return this.getKpiByString('TD procedure requirements')
      },

      // 4
      getKpiOffer: function() {
        return this.getKpiByString('4. Offer')
      },
      getKpiOfferStandardsFullfilled: function() {
        return this.getKpiByString('Offer standards fulfilled')
      },
      getKpiSFProductRatio: function() {
        return this.getKpiByString('BMW\/MINI SF product ratio')
      },
      getKpiOfferTradeInOffer: function() {
        return this.getKpiByString('Trade-in Offer')
      },
      getKpiOfferMarketingOptIn: function() {
        return this.getKpiByString('Marketing Opt-In')
      },

      // 5
      getKpiContactCare: function() {
        return this.getKpiByString('5. Contact Care')
      },
      getKpiContactCareCourtesyMessage: function() {
        return this.getKpiByString('Courtesy message (4 hrs.)')
      },
      getKpiContactCareCourtesyMessageContent: function() {
        return this.getKpiByString('Courtesy Message Content')
      },
      getKpiContactCareAppointmentFU: function() {
        return this.getKpiByString('Appointment FU')
      },
      getKpiContactCareFollowUp: function() {
        return this.getKpiByString('Follow-up on offer')
      },

      getKpiContactCareFollowUpOnline: function() {
        return this.getKpiByString('5B.1 Follow-up on offer (Onl.)')
      },
      getKpiContactCareMessageInformation: function() {
        return this.getKpiByString('5A.1.1 Message information')
      },

      // CSQ: Germany
      getKpiContactCareCsqAppointment: function() {
        return this.getKpiByString('DE-1 Appointment for FU')
      },
      getKpiContactCareCsqPremium: function() {
        return this.getKpiByString('DE-02 Premium dealership')
      },
      getKpiContactCareCsqVisitorExperience: function() {
        return this.getKpiByString('DE-03 Visitor experience')
      },

      // 6
      getKpiRecommendation: function() {
        return this.getKpiByString('Recommendation')
      },
      getKpiRecommendationBrand: function() {
        return this.getKpiByString('Recommendation Brand')
      },

      // xEV
      getKpixEvNeedAnalysis: function() {
        return this.getKpiByString('xEV Need analysis');
      },
      getKpixEvProductPresentation: function() {
        return this.getKpiByString('xEV Product presentation');
      },
      getKpixEvHomeChargingProducts: function() {
        return this.getKpiByString('Home charging products');
      },
      getKpixEvPublicChargingOffering: function() {
        return this.getKpiByString('Public charging offering');
      },
      getKpixEvGovRegionalSupport: function() {
        return this.getKpiByString('Gov.\/regional support');
      },
      getKpixEvTestDriveRequirements: function() {
        return this.getKpiByString('TD further requirements');
      },

      // GKL
      getKpiGklVehiclePresentation: function() {
        return this.getKpiByString('GKL+ vehicle presentation');
      },
      getKpiGklDeliveryOfTestVehicle: function() {
        return this.getKpiByString('GKL+ Delivery of TD vehicle');
      },
      getKpiGklTestDriveExperience: function() {
        return this.getKpiByString('GKL+ TD experience');
      },
      getKpiGklCustomerTreatment: function() {
        return this.getKpiByString('GKL + Customer treatment');
      },

      // Excitement
      getDigitalReadinessKpis: function() {
        return [
          this.getKpiExcitementDigital,
          this.getKpiExcitementPhysical,
          this.getKpiExcitementPsychological
        ];
      },
      getKpiExcitement: function() {
        return this.getKpiByString('Excitement')
      },
      getKpiExcitementDigital: function() {
        return this.getKpiByString('Excitement Digital')
      },
      getKpiExcitementPhysical: function() {
        return this.getKpiByString('Excitement Physical')
      },
      getKpiExcitementPsychological: function() {
        return this.getKpiByString('Excitement Psychological')
      },

      // Digital readiness
      getKpiDigitalReadiness: function() {
        return this.getKpiByString('Digital readiness')
      },
      getKpiDigitalReadinessDirectAppointmentBookingOnline: function() {
        return this.getKpiByString('Direct Appointment Booking Online')
      },
      getKpiDigitalReadinessOnlineConsultationOffered: function() {
        return this.getKpiByString('Online Consultation offered')
      },
      getKpiDigitalReadinessMyBMWApp: function() {
        return this.getKpiByString('My BMW/MINI App')
      },

      // LM's
      getKpiLegendaryMomentIntegratedOffer: function() {
        return this.getKpiGroupByString2('Legendary Moment: Integrated offer')
      },
      getKpiLegendaryMomentTestDrive: function() {
        return this.getKpiGroupByString2('Legendary Moment: Test Drive')
      },

      getKpiBatteryChargingStatus() {
        return this.getKpiByString('Battery Charging Status')
      }
     
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/bmw/_variables.scss";

  .bl-container {
    min-height: unset!important;
  }

.over2 {
  text-align: left!important;
  margin: 0!important;
}

  .pi-color-fix {
    color: $body-color;
  }

  .ti_border_inactive {
    opacity: 0.3;
  }

.dnt {
  display: grid;
  grid-template-columns: 1fr 96px 1fr;
  height: 96px;
}

.card {
  border: solid #000;
  border-width: 2px;
  border-radius: 0rem;
  margin-left: 0px;
}

.card-body {
  padding: 0pc;
  margin-left: 0pc;
}

.card-header {
  background: #0f0;
  height: 0px;
  margin: 0px;
  padding: 0px;
  border: solid #00F;
  border-width: 0px;
}

h3 {
  height: 36pt;
  line-height: 28pt;
  text-align: center;
  color: #111111;
  font-size: 16pt;
  font-stretch: extra-condensed;
}

.xev-spacing {
  margin: 2px; 
  padding-top: 2px;
}

.span-two {
  grid-column: 2 / 4; /* Beginnt bei Spalte 1 und erstreckt sich bis vor Spalte 3 */
  min-width: 448px;
}

.retail-next-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2px 1rem;
  margin:1rem;
}

.retail-next-area {
  border: 1px $bmw-bd21 solid;
  height: 100%;
}

.retail-next-header {
  text-align: center; 
  text-transform: uppercase; 
  border: 1px $bmw-bd21 solid;
  background: $bmw-bg21;
  color: white;
  width:10rem; 
  margin-inline: auto;
}
</style>
